<!--
 * @Author: Merlin
 * @Date: 2024-10-11 17:58:23
 * @LastEditors: Merlin
 * @LastEditTime: 2025-05-29 17:26:58
 * @Description: 
游戏进行期间需要进行标记状态： joinStore.gameRunning = true; 
游戏内的常量 13 （最后一层），应改用接口返回的数组长度 

-->
<template>
    <NuxtLayout name="casino">
        <div class="stairs-container">
            <ClientOnly>
                <GameSettingsDiceTabsWrapper class="flex !justify-end !mb-4 !mt-0.5">
                    <GameSettingsButtonLiveChat v-if="useUserStore().isLoggedIn" v-model="isOpenLiveChat" />
                    <GameSettingsButtonFast v-model="game.stairs.fast" />
                    <GameSettingsButtonFairness v-model="isOpenFairness" />
                    <GameSettingsButtonRule v-model="isOpenRule" name="stairs" />
                    <GameSettingsButtonVocie
                        v-model="settingStore.inhouseGames.sound.on"
                        v-model:voice-model-value="settingStore.inhouseGames.sound.music"
                        :saveAfterChange="true"
                    >
                    </GameSettingsButtonVocie>
                </GameSettingsDiceTabsWrapper>
            </ClientOnly>
            <!-- 
                ↑ 顶部菜单
                ↓ 舞台
            -->
            <ClientOnly>
                <div class="flex w-full gap-3 relative stairs-content">
                    <Board
                        id="board"
                        :man="coefficients.man"
                        v-model:round="coefficients.round"
                        :bet-is-locked="coefficients.betIslocked"
                        :itemClick="itemClick"
                        :stairRows="stairRows"
                    />
                    <CoefficientsInner
                        :stone-num="coefficients.currentStone"
                        :level="coefficients.round.revealed.length"
                        :round="coefficients.round"
                        :stoneOptions="stoneOptions"
                    />
                    <CasinoModalResult
                        v-model:is-open="coefficients.isOpenResult"
                        :expected-reward="expectedReward"
                        :mutipl="currentMutipler"
                    />
                </div>
            </ClientOnly>
            <!-- 
                ↑ 舞台
                ↓ 用户表单区 
            -->
            <ClientOnly>
                <form @submit.prevent="handleSubmit" class="options-form">
                    <LevelOption
                        v-model:stone-num="coefficients.currentStone"
                        :auto-pick-function="autoPick"
                        :option-disabled="['cashout', 'play'].includes(coefficients.round.status)"
                        :is-submiting="oForm.isSubmiting"
                        :round="coefficients.round"
                        :stoneOptions="stoneOptions"
                        :auto-disabled="
                            ['', 'lose'].includes(coefficients.round.status) || coefficients.betIslocked
                        "
                    />

                    <CasinoBetOptionSection
                        class="stairs-option"
                        :betTookit="betTookit"
                        :auto-bet-tool-kit="autoBetToolKit"
                        v-model:bet-amount-modal-value="oForm.amount"
                        v-model:is-submiting="oForm.isSubmiting"
                        :sound="settingStore.globalSounds"
                        :isAuto="false"
                        :bet-submit="betSubmit"
                        :is-fast="game.stairs.fast"
                        :amount-disabled="['cashout', 'play'].includes(coefficients.round.status)"
                        :expected-reward="coefficients.round.status ? expectedReward : 0"
                        :normalBtnLable="cashAble ? t.CashOut : ''"
                        :normalBtnDisabled="
                            (!cashAble && ['play'].includes(coefficients.round.status)) ||
                            coefficients.betIslocked
                        "
                        btn-color-mode="secondaryContainedShadow"
                        :showSwitch="false"
                    />
                </form>
                <!-- <article v-if="tempTest">
                    <button @click="testOnly(0)">
                        开始爬山
                    </button>
                </article> -->
            </ClientOnly>
        </div>
    </NuxtLayout>
</template>

<script lang="ts" setup>
import { onMounted, ref, reactive, watch, computed } from 'vue';
import useTranslation from '~/i18n/useTransLation';
// stores
import useSettingsStore from '~/stores/settings';
import { useUserStore } from '~/stores/user';
import { useJoinStateStore } from '@/stores/cansino/joinState';
// socket
import { useGameSocket } from '~/socket/game';
// functions
import { useAutoBetToolKit } from '~/common/js/bettingToolkit/auto';
import { useBettingToolkit } from '~/common/js/bettingToolkit';
import { useStair } from '@/pages/casino/stairsGame/composable/useStair';
import { showTips4BadAmountIfNeeded } from '~/common/js/betHelper';
// components
import Board from './_components/Board.vue';
import LevelOption from './_components/LevelOption.vue';
import CoefficientsInner from './_components/CoefficientsInner.vue';
// assets
import { BetTypeEnum } from './data';
import MatchMp3 from '~/assets/mp3/match.mp3';
import StairsWinMp3 from './mp3/stairs-win.mp3';
import StairsBgm from '@/assets/mp3/game_general_bgm.mp3';
import placeBetSound from '@/assets/mp3/place-bet.mp3';
import losingSound from '~/assets/mp3/losing.mp3';
import winSound from '~/assets/mp3/win.mp3';

const isDev = import.meta.dev;
const settingStore = useSettingsStore();
const joinStore = useJoinStateStore();
const t = useTranslation();
const { EMIT_STAIRS_BET } = useGameSocket();
const isOpenFairness = ref(false);
const isOpenRule = ref(false);
const isOpenLiveChat = ref(false);
const { game } = storeToRefs(settingStore);

const oForm = reactive({
    amount: 0,
    isSubmiting: false,
});

let musicControler = null;
const {
    coefficients,
    handleManPosition,
    cashAble,
    resetCoefficients,
    stoneOptions, // obj 每层楼的赔率信息 
    stairRows, // arr 每层楼的布局 
} = useStair(musicControler);

const oMusicLib = {
    bg: {
        src: StairsBgm,
        loop: true,
        isBGM: true, // true-false 表示音量取自 globalVolume, globalSoundEffects
    },
    placeBet: {
        src: placeBetSound,
    },
    match: {
        src: MatchMp3,
    },
    stairsWin: {
        src: StairsWinMp3,
    },
    lose: {
        src: losingSound,
    },
    win: {
        src: winSound,
    },
};

// 用于测试 
const tempTest = Date.now() < new Date('2025-05-30 23:59:59').getTime();
async function testOnly(iDelay=0){
    await Sleep(iDelay); 
    if (
        // !import.meta.dev
        !tempTest
        || coefficients.round['winAmount'] > 0
    ) return;
    coefficients.currentStone = 1; // 最简单模式 
    oForm.amount = Math.random() * 15 + 1; 
    await betSubmit(); // 开局 
    // 最多可以向上爬 13 层，到达 13 层之后无论输赢游戏都将结束 
    for (const idx of Array(12).keys()){
        await (window as any).scheduler.yield();
        if (joinStore.gameName != 'stairsGame'){
            return; // 离开了游戏 
        }
        // (settingStore.game as any).stairs.fast = idx < 10;
        await autoPick();
        await nextTick();
        await Sleep(100);
        const {status, revealed} = coefficients.round; 
        console.log('已到达楼层：', revealed.length, `(${status})`);
        if (revealed.length == stairRows.length){
            console.log(`登顶状态：`, status); 
        }else if (status === 'lose'){
            setTimeout(()=>testOnly(0), 100);
            return;
        }
    }
}

onMounted(async () => {
    // import.meta.dev && (window['testOnly'] = testOnly) // 测试 
});

onUnmounted(() => {
    musicControler?.toDestory();
});

const betTookit = useBettingToolkit(oForm);
/**
 * 点击下注按钮 根据不同的状态调用下注按钮
 */
const betSubmit = async () => {
    console.log('click main button, status =', coefficients.round.status || '●'); 
    coefficients.round.level = 1;
    switch (coefficients.round.status) {
        case '':
        case 'lose':
            console.log('Start a new round');
            resetCoefficients(); // 返现后再点击下注按钮，需要将状态重置
            const res = await EMIT_STAIRS_BET({
                amount: oForm.amount.beFixed(2),
                count: coefficients.currentStone,
                type: BetTypeEnum.StartBet,
                frontID: new Date().getTime(),
            });
            if (!res || res.error){
                showNegativeNotify(res?.error); 
                return; 
            }
            console.log('The new round', deepCopy(res)); 
            coefficients.round.status = res.status;
            break;
        // ↓ 说明：但凡 status 状态是 cashout 表示游戏结束了（通过登顶或提现）所以断然不能执行下方语句
        // ↓ 所以下方区块的存在疑似不当，因为有可能永远不会执行 
        case 'cashout':
            const res2 = await EMIT_STAIRS_BET({
                type: BetTypeEnum.CashOut,
                frontID: new Date().getTime(),
            });
            coefficients.isOpenResult = true;
            musicControler?.oAudio.win.play();
            // 点击返现以后所有石头落下，再点击下注按钮才会回到初始状态
            coefficients.round.multi = res2.multi;
            coefficients.round.status = '';
            coefficients.round.field = res2.state?.field || [];
            coefficients.round.revealed = res2.state.revealed;
            coefficients.winAmount = res2.winAmount;
            if (!res2.state?.field){
                console.error('field 信息缺失 A', deepCopy(res2));
            }
            break;
        case 'play':
            // 以下是提现操作
            if (!cashAble.value) break;
            console.log('To cash out');
            coefficients.round.status = ''; // 置于顶部，用于及时禁用【自动选择】按钮 
            const res3 = await EMIT_STAIRS_BET({
                type: BetTypeEnum.CashOut,
                frontID: new Date().getTime(),
            });
            // 当有未完成的游戏时，点击返现时status时play，需要展现返现时的动画效果
            coefficients.isOpenResult = true;
            musicControler?.oAudio.win.play();
            // 点击返现以后所有石头落下，再点击下注按钮才会回到初始状态
            coefficients.round.multi = res3.multi;
            coefficients.round.field = res3.state?.field || [];
            coefficients.round.revealed = res3.state.revealed;
            coefficients.winAmount = res3.winAmount;
            await Sleep(coefficients.insertDelay); // 添加延时，等待delay数据处理完后再执行插入操作
            joinStore.showDateInQueue(); // 插入游戏结果并播放动画
            if (!res3.state?.field){
                console.error('field 信息缺失 B', deepCopy(res3));
            }
            break;
        default:
            console.error('coefficients.round.status value wrong', coefficients.round.status);
    }
};

/**
 * 点击AutoPick按钮随机选择位置下注
 */
const autoPick = async () => {
    if (
        coefficients.round.status === '' ||
        coefficients.round.status === 'lose' ||
        coefficients.round.revealed.length === stairRows.length
    )
        return;
    musicControler?.oAudio.placeBet.play();
    const nextRow = stairRows[coefficients.round.revealed.length] || { length: 10, offset: 0 };
    const randomPicked = getRandomInt(nextRow.offset, nextRow.length);
    coefficients.betIslocked = true;
    await manGoTo(randomPicked);

    coefficients.betIslocked = false;
};

/**
 * 手动选择位置下注
 * @param index 
 */
const itemClick = async (index) => {
    if (
        coefficients.betIslocked ||
        coefficients.round.status === 'lose' ||
        coefficients.round.status === ''
    )
        return;
    musicControler?.oAudio.placeBet.play();
    const nextRow = stairRows[coefficients.round.revealed.length] || { length: 10, offset: 0 };
    coefficients.betIslocked = true;
    await manGoTo(index - nextRow.offset);
    coefficients.betIslocked = false;
};

const getRandomInt = (min, max) => {
    return Math.floor(Math.random() * (max - min)) + min;
};
/**
 * 选取不同位置时进行下注操作
 * @param step 下标，选择某一行的第几个位置
 */
const manGoTo = async (step: number) => {
    const [_, res] = await Promise.all([
        manAnimation(step), // ←这里修改了 coefficients.round.revealed 
        EMIT_STAIRS_BET({
            revealed: [step],
            type: BetTypeEnum.NextBet,
            isFast: false,
        }),
    ]);
    console.log('Go target:', step, '| get multi:', res.multi);
    console.log(`Go result (${res.status || '●'})\n`, deepCopy(res));
    musicControler?.oAudio.match.play();
    coefficients.round.multi = res.multi;
    coefficients.round.status = res.status === 'cashout' ? '' : res.status;
    coefficients.round.field = res.state?.field || [];
    coefficients.winAmount = res.winAmount;
    coefficients.round.revealed = res.state.revealed;
    const isLastRound = coefficients.round.revealed.length === stairRows.length; 
    if (isLastRound && res.winAmount) {
        musicControler?.oAudio.stairsWin.play(); 
    }
    if (res.status === 'lose') {
        coefficients.man.animation = 'lose';
        await Sleep(coefficients.insertDelay); // 添加延时，等待delay数据处理完后再执行插入操作
        joinStore.showDateInQueue(); // 插入游戏结果并播放动画
    } else if (res.status === 'cashout'){ // 登顶
        await Sleep(coefficients.man.animationTime); // 添加延时，等待delay数据处理完后再执行插入操作
        joinStore.showDateInQueue(); // 插入游戏结果并播放动画
    }
};

/**
 * 人物移动动画
 * @param step 
 */
const manAnimation = async (step) => {
    // Update round stairs and calculate position
    coefficients.round.revealed.push(step);
    const currentRow = stairRows[coefficients.round.revealed.length - 1];

    const boradWidth = document.getElementById('board').offsetWidth;
    const boardHeight = document.getElementById('board').offsetHeight;
    const stepWidth = boradWidth / 10;
    const currentBoard = step + 1 + currentRow.offset;
    const positionX = stepWidth * currentBoard - stepWidth / 2;
    const positionXPercentage = (positionX / boradWidth) * 100;

    // If in fast mode, update position and level immediately
    if (game.value.stairs.fast) {
        coefficients.round.level += 1;
        const boardElement = document.getElementById('board');
        handleManPosition(boardElement);
    } else {
        // If position X is different, trigger running animation
        if (coefficients.man.position.x !== positionX) {
            coefficients.man.isLeft = positionX < coefficients.man.position.x;
            coefficients.man.position.x = positionXPercentage;
            coefficients.man.animation = 'run';
            coefficients.man.isAnimating = true;
            await Sleep(coefficients.man.animationTime);

            coefficients.man.isAnimating = false;
        }
        coefficients.man.animation = 'climb';

        coefficients.man.position.y += boardHeight / 13;
        // 往上爬的时间
        await Sleep(coefficients.man.animationTime); // Delay function
        coefficients.man.isAnimating = false;
        coefficients.man.animation = '';
    }
};

const autoBetToolKit = useAutoBetToolKit(oForm, betSubmit as any);

const expectedReward = computed(() => {
    const result = oForm.amount * coefficients.round.multi;
    // if (result <= 0) return null;
    return result;
});
const currentMutipler = computed(() => {
    const ind = (
        coefficients.round.revealed.length
        ? coefficients.round.revealed.length - 1
        : 0
    );
    return stoneOptions[coefficients.currentStone][ind];
});
/**
 * 阻止form表单的默认提交行为，以防止页面刷新
 * @param e event
 */
const handleSubmit = (e) => {
    e.preventDefault()
}
watch(
    () => coefficients.round.status,
    (val) => {
        if (val === 'lose') {
            musicControler?.oAudio.lose.play();
        }
    },
);
watch(
    () => settingStore.inhouseGames.sound.on,
    (newVal) => {
        if (newVal && !musicControler && import.meta.client) {
            musicControler = new MusicControler(oMusicLib);
        }
    },
    {
        immediate: true,
    }
);

let time01 = null;
// ↓ 提示用户“非理性” 投注金额（但几乎无法触发）
watch([
    () => oForm.amount,
    () => coefficients.currentStone,
    () => coefficients.round.revealed,
], (newArr)=>{
    clearTimeout(time01);
    const val01 = coefficients.winAmount > 0;
    // 需要延时，防止游戏终止(输)后仍然弹出提示 
    time01 = setTimeout(()=>{
        if (val01 && !coefficients.winAmount){
            return; // 突然输了，不提示 
        }
        const ind = coefficients.round.revealed.length;
        const expectingMulti = stoneOptions[coefficients.currentStone][ind]; 
        if (!expectingMulti) return; 
        const expectingReward = oForm.amount * expectingMulti;
        console.log('期待赔付倍数与金额：', expectingMulti + '倍__', expectingReward.toLocaleString()); 
        showTips4BadAmountIfNeeded(expectingReward);
    }, 500);
});

</script>

<style lang="scss" scoped>
.stairs-container {
    @media (max-width: 768px) {
        padding: 2px 4px;
    }
}
.stairs-content {
    flex-direction: row-reverse;
}
.options-form {
    display: flex;
    flex-direction: column;
    @media (max-width: 576px) {
        >div {
            &:first-child{
                margin: 0;
                order: 2;

            }
            &:last-child {
                margin: 10px 0;
                order: 1;
            }
        }
        :deep(.expected-label){
            font-size: 14px;
        }
        :deep(.expected-reward){
            font-size: 12px;
        }
    }
}
</style>